import { TopProject } from "../types/globalTypes";

export const getNewProjectsByDate = (projects: TopProject[]): TopProject[] => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  return projects.filter(project => {
    if (!project.BecameAvailableDate) return false;
    const createdAt = new Date(project.BecameAvailableDate);
    return createdAt >= oneMonthAgo;
  });
};
